import { Wifi } from "lucide-react";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function WifiSection() {
  return (
    <section id="wifi" aria-labelledby="wifi-heading" className="bg-background py-16 md:py-20">
      <div className="shell grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>Stay Connected</Eyebrow>
          </Reveal>
          <h2 id="wifi-heading" className="display-lg mt-6 max-w-[14ch]">
            <MaskReveal>WiFi for the Moments</MaskReveal>
            <MaskReveal delay={0.08}>You Need It</MaskReveal>
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-muted-foreground">
              Complimentary WiFi is available for Auburn RV Resort guests, making it easier to stay
              connected during your travels.
            </p>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-muted-foreground">
              Check messages, plan tomorrow&apos;s adventure or stay connected with family while
              you&apos;re on the road.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.08} className="lg:col-span-6">
          <div className="relative overflow-hidden border border-border bg-secondary/35 px-8 py-10 md:px-12 md:py-14">
            <div className="absolute inset-x-8 top-10 flex justify-center gap-2 opacity-40 md:inset-x-16">
              {[1, 2, 3, 4].map((n) => (
                <span
                  key={n}
                  className="block h-10 w-px origin-bottom bg-primary/50"
                  style={{ transform: `scaleY(${0.35 + n * 0.2})` }}
                  aria-hidden="true"
                />
              ))}
            </div>
            <div className="relative mx-auto flex max-w-sm flex-col items-center text-center">
              <span className="flex size-16 items-center justify-center rounded-full border border-border bg-background text-primary">
                <Wifi className="size-7" strokeWidth={1.4} aria-hidden="true" />
              </span>
              <p className="eyebrow mt-8 text-primary">RV Park with WiFi Auburn CA</p>
              <p className="font-display mt-4 text-3xl tracking-tight">Stay Connected Simply</p>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
                A helpful connection for travel days, check-ins and planning your next Sierra
                Foothills adventure.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
